import React from 'react';
import { IconSpinner, Modal, Skeleton } from '../../../../components';
import { manageDisableScrolling } from '../../../../ducks/ui.duck';
import BookmarkContainer from './BookmarkContainer';
import css from './BookmarkContainer.module.css';
const BookmarkModal = props => {
  const {
    isBookmarkListRequested,
    setIsBookmarkListRequested,
    bookmarksListData,
    onDeleteBookMark,
    requestBookmarksList,
    history,
    routeConfiguration,
    spaceListData,
    onSetActiveTab,
    onManageDisableScrolling
  } = props;
  const { records } = bookmarksListData || {};
  const handleClose = () => {
    onSetActiveTab()
    setIsBookmarkListRequested(false)
  }
  return (
    <>
      <Modal
        id="bookmarkModal"
        isOpen={isBookmarkListRequested}
        onClose={() => handleClose()}
        onManageDisableScrolling={onManageDisableScrolling}
        className={css.bookmarkContainer}
      >
        <div>
          <div className={css.savedHeading}>Saved posts</div>
          {requestBookmarksList ? (
            <Skeleton type={true} />
          ) : records?.length === 0 ? (
            <div>No saved posts</div>
          ) : (
            records
              ?.filter(item => item.bookmark_type === 'post' && !item?.is_deleted)
              .map((item, index) => (
                <BookmarkContainer
                  bookmarkRecord={item?.bookmark_record}
                  key={item.id}
                  onDeleteBookMark={onDeleteBookMark}
                  bookmarkId={item?.id}
                  setIsBookmarkListRequested={setIsBookmarkListRequested}
                  history={history}
                  routeConfiguration={routeConfiguration}
                  spaceListData={spaceListData}
                />
              ))
          )}
        </div>
      </Modal>
    </>
  );
};

export default BookmarkModal;
